import { Controller } from "@hotwired/stimulus"

// Toggles a password field between hidden and visible, swapping the
// trailing eye icon to match (used on the auth pages).
export default class extends Controller {
  static targets = ["input", "icon"]

  toggle() {
    const showing = this.inputTarget.type === "text"

    this.inputTarget.type = showing ? "password" : "text"
    this.iconTarget.classList.toggle("ri-eye-line", !showing)
    this.iconTarget.classList.toggle("ri-eye-off-line", showing)
  }
}
